// src/theme/components/radio.js
import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

// AI Temalı Varsayılan Radio Stili
const baseStyle = definePartsStyle((props) => {
  const { colorScheme: c } = props; // 'brand' veya diğerleri

  return {
    // Label Stili (Radio'nun yanındaki metin)
    label: {
      color: "textSecondary", // semantic token
      ml: 3, // Metin ile radio butonu arası boşluk
      _disabled: {
        opacity: 0.5,
      },
      // Seçiliyken label rengi daha belirgin olabilir (opsiyonel)
      // _checked: {
      //   color: "textPrimary",
      //   fontWeight: "medium",
      // },
    },
    // Control Stili (Radio'nun kendisi - daire)
    control: {
      bg: "inputBg", // semantic token (veya bgTertiary)
      borderColor: "inputBorder", // semantic token
      borderWidth: "2px", // Daha belirgin bir kenarlık
      transitionProperty: "common",
      transitionDuration: "var(--motion-duration-fast)",
      transitionTimingFunction: "var(--motion-ease-apple)",
      _checked: {
        bg: c === "brand" ? "accent" : `${c}.500`, // semantic token
        borderColor: c === "brand" ? "accent" : `${c}.500`,
        color: props.colorMode === 'dark' ? ( c === 'yellow' ? 'gray.900' : 'white' ) : ( c === 'yellow' ? 'gray.900' : 'white'), // İçindeki tik/nokta rengi
        _before: { // İçindeki nokta için stil (Chakra bunu kullanır)
          // bg: props.colorMode === 'dark' ? 'gray.900' : 'white',
        },
        _hover: {
          bg: c === "brand" ? "accentHover" : `${c}.600`,
          borderColor: c === "brand" ? "accentHover" : `${c}.600`,
        },
        _disabled: {
          bg: props.colorMode === 'dark' ? "whiteAlpha.200" : "gray.300",
          borderColor: props.colorMode === 'dark' ? "whiteAlpha.200" : "gray.300",
          color: props.colorMode === 'dark' ? "whiteAlpha.500" : "gray.500",
        },
      },
      _disabled: {
        bg: props.colorMode === 'dark' ? "whiteAlpha.100" : "gray.100",
        borderColor: props.colorMode === 'dark' ? "whiteAlpha.200" : "gray.200",
      },
      _hover: {
        borderColor: c === "brand" ? "accentHover" : `${c}.400`, // Normalde hover'da kenarlık değişimi
      },
      _focusVisible: { // Klavye ile odaklandığında
        boxShadow: `0 0 0 3px var(--chakra-colors-${c}-${props.colorMode === 'dark' ? 300 : 500}-alpha-50)`, // colors.js'de tanımlı olmalı
        // Veya semantic token: boxShadow: "var(--chakra-shadows-focusOutlineAccent)",
        outline: "none",
      },
      // Boyutlar
      w: "1.25rem", // 20px
      h: "1.25rem",
      _checkedBefore: { // İç nokta boyutu
        w: "0.625rem", // 10px
        h: "0.625rem",
      }
    },
    // Container stili (tüm radio elemanını kapsar)
    container: {
      // Gerekirse ek stil
    }
  };
});

export const radioTheme = defineMultiStyleConfig({
  baseStyle,
  // Farklı boyutlar (sm, md, lg) için stiller de eklenebilir.
  // sizes: {
  //   md: definePartsStyle({ // Varsayılan boyut
  //     control: { w: 5, h: 5 },
  //     label: { fontSize: "md" },
  //   }),
  //   lg: definePartsStyle({
  //     control: { w: 6, h: 6 },
  //     label: { fontSize: "lg" },
  //   }),
  // },
  defaultProps: {
    colorScheme: "brand", // Varsayılan renk şeması
    // size: "md", // Varsayılan boyut
  },
});

export default radioTheme; // index.js'de Radio: radioTheme olarak kullanılacak
